import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Moment from "react-moment";
import Dialog from "@mui/material/Dialog";
import NoticeDetail from "./NoticeDetail";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import "../css/notice.css";
import { config } from "../config/config";

const NoticeItems = styled.div`
  word-break: keep-all;
  list-style-type: none;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--text-color);
  padding: 0px;
  background-color: var(--bg-color);
  width: 100%;
`;

const Title = styled.div`
  margin-top: 1rem;
  height: 1.625rem;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 1.063rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: justify;
  color: var(--text-color);
`;
const Description = styled.div`
  font-size: 0.875rem;
  line-height: 1.33;
  letter-spacing: normal;
  color: var(--text-color_sub1);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
`;

const Date = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.688rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.27;
  letter-spacing: normal;
  // padding-top: 5px;
  color: var(--text-color_sub2);
`;

const importantIcon = (important) => {
  if (important) {
    // Detect dark mode using matchMedia
    const isDarkMode =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    const fillColor = isDarkMode ? "#FF9F0A" : "#FF9500";

    return (
      <svg width="14" height="14" viewBox="0 0 14 14">
        <defs>
          <path
            id="prefix__a"
            d="M1.866 11.445l2.76-3.235 1.168 1.167L2.56 12.14c-.09.074-.204.113-.321.11-.191-.002-.364-.113-.444-.287-.08-.174-.052-.378.07-.524v.006zm6.24-1.319c.15.15.377.195.573.112.196-.083.321-.277.318-.49v-1.78l2.924-1.782c.161-.093.275-.25.314-.432.04-.182 0-.372-.108-.523L8.773 1.874c-.151-.109-.34-.148-.522-.11-.182.04-.339.154-.432.315L6.04 5.007H4.258c-.213-.002-.405.126-.487.323-.08.197-.034.424.118.573l4.218 4.223z"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <path d="M0 0H14V14H0z" />
          <mask id="prefix__b" fill="#fff">
            <use href="#prefix__a" />
          </mask>
          <path
            fill={fillColor}
            fillRule="nonzero"
            d="M0 0H14V14H0z"
            mask="url(#prefix__b)"
          />
        </g>
      </svg>
    );
  } else {
    return "";
  }
};

const Notice = ({
  id,
  title,
  subtitle,
  description,
  createdAt,
  publishedAt,
  files,
  language,
  important,
  className,
  header,
}) => {
  // console.log(id, title, subtitle, description, createdAt, publishedAt, files , language, important, className);
  //const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // // // 태그삭제 및 줄 바꿈제거
  const removeTag = (item) => {
    if (item) {
      var listDescription = item
        .replace(/<(\/)?[Pp](\/)?>/g, " ")
        .replace(/(<li>)|(<\/li>)/gi, " ")
        .replace(/(<br>|<br\/>|<br \/>)/g, " ")
        .replace(/(<([^>]+)>)/gi, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&nbsp;/gi, " ")
        .replace(/(\r\n|\n|\r)/gm, " ")
        .replace(/&amp;/gi, "&");
    }
    return listDescription;
  };

  // var datetime = publishedAt && publishedAt != null ? publishedAt : createdAt;
  var datetime = createdAt && createdAt != null ? createdAt : publishedAt;

  return (
    <>
      <NoticeItems
        id={id}
        onClick={handleClickOpen.bind(this)}
        className={
          (config.SPACE_FREE.indexOf(language) !== -1 ? "isBreakAll" : "") +
          " " +
          className
        }
      >
        <div style={{ display: "flex", position: "relative" }}>
          <div style={{ minWidth: "2.2625rem", paddingBottom: "10px" }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
              style={{
                marginLeft: "0px",
                width: "100%",
                // height: "100%",
                color: "#ff5252",
                padding: "2px 12px 12px 12px",
                marginTop: "18px",
              }}
              size="large"
            >
              {/* <CheckCircleOutline  style={{ fontSize: '0.375rem' }}/> */}
              {importantIcon(important)}
            </IconButton>
          </div>
          <div
            className="notice-body"
            style={{
              borderBottom: "solid 0.0625rem var(--divider-color)",
            }}
          >
            <Title
              className="list-width"
              dir={config.ARAB.indexOf(language) !== -1 ? "rtl" : ""}
            >
              {title}
            </Title>
            <Description
              dir={config.ARAB.indexOf(language) !== -1 ? "rtl" : ""}
            >
              {/* {description} */}
              {removeTag(description)}
            </Description>
            <Date dir={config.ARAB.indexOf(language) !== -1 ? "rtl" : ""}>
              <Moment format="MMM DD, YYYY">{parseInt(datetime)}</Moment>
            </Date>
          </div>
          <div
            style={{
              paddingRight: "0.375rem",
              minWidth: "3.5rem",
              borderBottom: "solid 0.0625rem var(--divider-color)",
              paddingBottom: "10px",
            }}
          >
            <IconButton
              edge="end"
              color="inherit"
              aria-label="close"
              style={{
                marginRight: "0px",
                padding: "0px 12px 12px 12px",
                marginTop: "16px",
                width: "100%",
                height: "100%",
              }}
              size="large"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="40"
                height="40"
                viewBox="0 0 20 20"
              >
                <defs>
                  <path
                    id="ute3be6ata"
                    d="M11.869 5c.427 0 .78.322.828.736l.005.097v8.334c0 .46-.373.833-.833.833-.427 0-.78-.322-.828-.736l-.005-.097-.001-7.501h-7.5c-.427 0-.78-.321-.827-.735l-.006-.098c0-.427.322-.78.736-.827L3.536 5h8.333z"
                  />
                </defs>
                <g fill="none" fillRule="evenodd">
                  <g>
                    <g>
                      <g transform="translate(-600 -65) translate(0 44) translate(600 21)">
                        <path d="M0 0H20V20H0z" />
                        <mask id="um23ms47db" fill="#fff">
                          <use xlinkHref="#ute3be6ata" />
                        </mask>
                        <use
                          fill="currentColor"
                          fillOpacity=".2"
                          fillRule="nonzero"
                          transform="scale(1 -1) rotate(45 31.844 0)"
                          xlinkHref="#ute3be6ata"
                        />
                        <path d="M0 0H20V20H0z" mask="url(#um23ms47db)" />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </IconButton>
          </div>
        </div>
      </NoticeItems>
      <Dialog
        fullScreen
        open={open}
        PaperProps={{
          style: {
            backgroundColor: "var(--bg-color)",
          },
        }}
        onClose={handleClose}
      >
        <AppBar
          style={{
            backgroundColor: "var(--bg-color)",
            position: "fixed",
            minHeight: "2.75rem",
            boxShadow: "none",
          }}
        >
          <Toolbar
            style={{
              minHeight: "2.75rem",
              marginTop: "4px",
              padding: "0px 1.1875rem",
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              style={{ padding: "0px", marginLeft: "0px" }}
              size="large"
            >
              <svg width="1.625rem" height="1.625rem" viewBox="0 0 26 26">
                <g
                  fill="none"
                  fillRule="evenodd"
                  stroke="var(--text-color_sub1)"
                  strokeLinecap="round"
                  strokeWidth="2"
                >
                  <path d="M7.757 13.243l8.486 8.486M16.242 4.757l-8.485 8.486" />
                </g>
              </svg>
            </IconButton>
          </Toolbar>
        </AppBar>
        <button
          id="backkeyTrigger_child"
          style={{ display: "none" }}
          onClick={handleClose}
        ></button>
        <div className="header-size-element" />
        <NoticeDetail
          id={id}
          title={title}
          subtitle={subtitle}
          description={description}
          createdAt={parseInt(createdAt)}
          publishedAt={parseInt(publishedAt)}
          files={files}
          onClose={handleClose}
          language={language}
        />
      </Dialog>
    </>
  );
};

Notice.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
};

export default Notice;
